<template>
   <div>
      <p style="display: flex;
         font-size: 30px;
         flex-direction: row;
         height: 45px;
         color: rgb(2215,114,2);
         border-bottom: solid 0.06rem rgb(193,193,193);">
         Search protein
      </p>
      <el-tabs v-model="activeOmics" type="border-card" style="width:55%;display: inline-block;height:400px;font-size:17px" @tab-click="handleClick">
         
         <el-tab-pane style="height:350px;" label="By UniProt accession" name="uniprot_accession">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="uniprotAccessionText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_uniprot_accession.txt" download="example_uniprot_accession.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               margin-top: 15px;
               height:65px;
               margin-left: auto;
               margin-right: auto;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 15px;">
                  Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
            
            </el-card> 
         </el-tab-pane>
     
         <el-tab-pane style="height:350px;" label="By UniProt entry name" name="uniprot_entry_name">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="uniprotEntryNameText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_uniProt_entry_name.txt" download="example_uniProt_entry_name.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
                  <!-- <div class="el-upload__tip" slot="tip">Only txt files can be uploaded, and not more than 500kb</div> -->
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               margin-top: 15px;
               height:65px;
               margin-left: auto;
               margin-right: auto;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 15px;">
                  Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
            
            </el-card> 
         </el-tab-pane>
         
         <el-tab-pane style="height:350px" label="By protein name" name="protein_name">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="proteinNameText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_protein_name.txt" download="example_protein_name.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               height:66px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 14px;">
               <div>
                  Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
               </div>
            
            </el-card> 
         </el-tab-pane>

         <el-tab-pane style="height:350px" label="By categories" name="categories">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="categoriesText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_categories.txt" download="example_categories.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               height:66px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 14px;">
               <div>
                  The categories here means category name from proMENDA database. Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
               </div>
            
            </el-card> 
         </el-tab-pane>

         <el-tab-pane style="height:350px" label="By tissue" name="tissue">
            <!-- textarea -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align: top">
               <p>
                  Enter one-per-line list<a href="javascript:void(0)" @click="fillText">(example)</a>
               </p>
               <el-input
                  type="textarea"
                  class="search"
                  :rows="5"
                  placeholder="Please enter your list here"
                  resize=none
                  v-model="tissuesText">
               </el-input>
            </div>
            <!-- file -->
            <div style="width:50%;height:180px;display: inline-block;vertical-align:top">
               <p>
                  Or upload a file(.txt)<a href="./file/example_tissue.txt" download="example_tissue.txt">(example)</a>
               </p>
               <el-upload
                  ref="upload"
                  action="alert"
                  :limit="1"
                  :on-exceed="handleExceed"
                  drag
                  :auto-upload="false"
                  :file-list="uploadFiles"
                  :on-change="handleChange"
                  :on-remove="handleRemove"
               >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">Drag the file here, or click to upload</div>
                  <!-- <div class="el-upload__tip" slot="tip">Only txt files can be uploaded, and not more than 500kb</div> -->
               </el-upload>
            </div>
            <!-- submit -->
            <el-button size="small" @click="submit" type="warning" style="width:95%;font-size: 16px;margin-top: 30px;">Submit</el-button>   
            <el-card style="width:95%;
               height:66px;
               margin-left: auto;
               margin-right: auto;
               margin-top: 15px;
               background-color: rgba(255,208,75,0.05);
               color: rgb(250,170,0);
               font-size: 14px;">
               <div>
                  The tissue here means tissue name from proMENDA database. Only txt files can be uploaded, and not more than 500kb. 
                  The input cannot exceed 200 entries
               </div>
            
            </el-card> 
         </el-tab-pane>

      </el-tabs>
      <div style="width:44%;height:400px;margin-left:0;display: inline-block;vertical-align: top">
         <BarOverlapchartVue ref="gene_bar" type="protein" style="width:550px;height:100%;margin:auto"/>
      </div>
    
      <el-card class="box-card">
         <el-table ref="proteinTable" id="table" :data="tableData" style="width: auto" height=630px @sort-change='sortChange' :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}"   >
            <el-table-column prop="uniprot_accession" label="UniProt accession" sortable="true" width="200" fixed></el-table-column>
            <el-table-column v-for='(item,key) in proteinFields' :key='key' :formatter="item.formatter" :prop='item.key' :label='item.label' :sortable="item.sortable" :width="item.width" :minWidth="item.minWidth">  
               <template v-if="item.key === 'pmid'" v-slot="scope">
                  <a :href="`https://www.ncbi.nlm.nih.gov/pubmed/${scope.row.pmid}`">{{ scope.row.pmid }}</a>
                  </template>
            </el-table-column>          
         
         </el-table>
         <el-pagination
            @size-change="(val) => handleSizeChange(val)"
            @current-change="(val) => handleCurrentChange(val)"
            :current-page="currentPage"
            :page-sizes="[10,20,30]"
            :page-size="10"
            layout="->,total, sizes, prev, pager, next, jumper"
            :total= this.totalCount
            style="margin-left:auto;">
         </el-pagination>
         <div style="text-align:left;margin:1%;line-height: 25px;">
            *Group: The comparison groups for each protein, from proMENDA.<br/>
            *Categories: A total of 18 categories from proMENDA, including 11 categories of human MDD and 6 categories of animal models.<br/>
            *Regulated: The protein was up or down-regulated.
         </div>
      </el-card>
   </div>
</template>
<script>
import{Loading}from'element-ui';
import BarOverlapchartVue from '../../chart/BarOverlapchart.vue';
   export default {
      data() {
         return {
            //table
            tableData:[],
            proteinFields: [  
                { key: "source", label: "Source", sortable: true,width:100},
                { key: "pmid", label: "PMID", sortable: true,width:120},
                { key: "uniprot_entry_name", label: "UniProt entry name", sortable: true,width:175},
                { key: "protein_name", label: "Protein name", sortable: true,width:150},
                { key: "gene_symbol", label: "Gene name",sortable: true,width:130},
                { key: "groups", label: "Groups", sortable: true,minWidth:130},
                { key: "categories", label: "Categories", sortable: true,width:120},
                { key: "organism", label: "Organism", sortable: true,width:110},
                { key: "tissue", label: "Tissue", sortable: true,width:100},
                { key: "regulated", label: "Regulated", sortable: true,width:113},
            ],
            currentPage:1,
            totalCount:0,
            pageSize:10,
            desc:null,
            sortby:null,
            //active
            activeOmics: 'uniprot_accession',
            // enter list
            uniprotAccessionText: '',
            uniprotEntryNameText:'',
            proteinNameText:'',
            categoriesText:'',
            tissuesText:'',
            uploadFiles: [],
            enterList:[],
         };
      },
      methods: {
         handleClick(tab, event) {
            this.uploadFiles = []
            this.enterList = []
         },
         getData(){
            var loadingInstance = Loading.service({
                target:document.querySelector('#table')
            });
            this.axios.post(this.GLOBAL.rootAddress+'search/protein/'+this.activeOmics,{
                  'pageNum': this.currentPage,
                  'pageSize': this.pageSize,
                  'sortBy':this.sortby,
                  'desc':this.desc,
                  'searchArray':this.enterList+''
               },{
            headers: {
               'Content-Type': 'application/x-www-form-urlencoded'
               }
            })
            .then(response=> {
               loadingInstance.close()
               this.totalCount=response.data.data.total;
               this.tableData=response.data.data.records;
               if(this.tableData.length==0){
                  this.$message.error('Sorry, no results found. Try different keywords.');
               }
            })
            .catch(error=> {
               loadingInstance.close()
               console.log(error);
            });
         },
        //table
         handleSizeChange(val) { 
            this.pageSize=val
            this.currentPage=1
            this.getData()            
         },
         handleCurrentChange(val) {
            this.currentPage=val
            this.getData()
         },
         sortChange(column, prop, order){
            this.currentPage=1
            if(column.order){
                this.sortby=column.prop
                if(column.order=='ascending'){
                    this.desc=1
                }else this.desc=0
            }else{
                this.sortby=null
                this.desc=0
            }
            this.getData()
         },
         //upload
         handleExceed(){
            this.$message.error('Only one file can be uploaded.');
         },
         handleRemove(file){
            this.uploadFiles=[]
         },
         handleChange(file, fileList){
            if (file.name.split('.').pop() !== 'txt'&& file.name.split('.').pop() !== 'TXT') { // 类型有可能大写
               fileList = []
               this.uploadFiles = []
               this.$message.error('Please up load file in txt format')
         }else if(file.size/1024>500){
               fileList = []
               this.uploadFiles = []
               this.$message.error('Please up load file no more than 500kby')
            }else{
               this.uploadFiles = fileList
         }

         },
         fillText(){
            switch(this.activeOmics){
               case 'uniprot_accession':
                  this.uniprotAccessionText='O08950\nP26772\nP04646\nP80254\nP22789\nP51672\nP17074\nP31044\nP62718';
                  return ;
               case 'uniprot_entry_name':
                  this.uniprotEntryNameText='F1LM47_RAT\nNDKB_RAT\nACON_RAT\nGSTP1_RAT\nGSTM7_RAT\nACTB_RAT\n1433Z_RAT\nLDHB_RAT\nANXA5_RAT\nEFHD2_RAT\nSTMN1_RAT\nSYN2_RAT\nCALR_RAT\nGBB2_RAT\n'
                  return;
               case 'protein_name':
                  this.proteinNameText='Aconitate hydratase, mitochondrial\nMethylmalonate-semialdehyde dehydrogenase [acylating], mitochondrial\nDual specificity mitogen-activated protein kinase kinase 1\nTropomyosin alpha-1 chain\nTubulin polymerization-promoting protein\nMICOS complex subunit Mic25\nTubulin beta-2B chain\nAlpha-soluble NSF attachment protein\nActin, cytoplasmic 1'
                  return;
               case 'categories':
                  this.categoriesText='Chronic mild stress model\nLipopolysaccharide induced depression model\nOther animal model\nPost-stroke depression\nSocial defeat model\nTreatment-resistant depression'
                  return;
               case 'tissue':
                  this.tissuesText='Plasma\nFaece\nAnterior cingulate cortex\nAnterior prefrontal cortex\nBrain\nCecum\nCerebellum\nCerebrospinal fluid\nCortex \n'
                  return;
            }
           
         },

         submit() {
            if (this.$refs.proteinTable){
               this.$refs.proteinTable.clearSort()
            }
            this.currentPage=1
            this.currentPageIndex=0
            this.desc=null
            this.sortby=null
            this.pageSize=10
            var textarea="";
            switch(this.activeOmics){
               case 'uniprot_accession':
                  textarea=this.uniprotAccessionText;
                  break;
               case 'uniprot_entry_name':
                  textarea=this.uniprotEntryNameText;
                  break;
               case 'protein_name':
                  textarea=this.proteinNameText;
                  break;
               case 'categories':
                  textarea=this.categoriesText;
                  break;
               case 'tissue':
                  textarea=this.tissuesText;
                  break;
              
            }
            if(this.uploadFiles.length){
               let file = this.uploadFiles[0]
               let reader = new FileReader()
               reader.readAsText(file.raw)
               reader.onload = (e) => {
                  this.enterList=e.target.result.split(/\r\n|\n\r|[\n\r]/)
                  //preprocess the data
                  this.enterList = this.enterList.filter((s) => {return s && s.trim(); });
                  this.enterList=this.enterList.map(function (item) {
                     return(item.trim().replace(',',"###"))
                  });
                  this.enterList = Array.from(new Set(this.enterList));
                  //warning
                  if(this.enterList.length>200){
                     this.$message.error('The input cannot exceed 200 entries.');
                  }else if(this.enterList.length==0){
                     this.$message.error('Please enter your list or upload a file!');
                  }else {
                     this.getData()
                     this.$message.success('You submitted the list in the file successfully.')
                  }
               }
            }else if(textarea){  
               var r = /\r\n|\n\r|[\n\r]/;
               this.enterList=textarea.split(r)
               //preprocess the data
               this.enterList = this.enterList.filter((s) => {return s && s.trim();});
               this.enterList=this.enterList.map(function (item) {
                     return(item.trim().replace(',',"###"))
                  });
               this.enterList = Array.from(new Set(this.enterList));
               //warning
               if(this.enterList.length>200){
                  this.$message.error('The input cannot exceed 200 entries.');
               }else if(this.enterList.length==0){
                  this.$message.error('Please enter your list or upload a file!');
               }else {
                  this.getData()
                  this.$message.success('You submitted the list in the textarea successfully.')
               }
            }else this.$message.error('Please enter your list or upload a file!');   
         }
      },
      mounted () {
         this.$refs.gene_bar.initChart()
      },
      components:{
         BarOverlapchartVue,
      }
   };
</script>

<style>
   .el-upload-dragger{
      height:120px !important;
      margin-left:5% !important;
      margin-right:5% !important;
      margin-top: 0;
      width:90% !important;
      
   }
   .el-icon-upload{
      margin: 10px 0 0px !important;
    }
    .el-card__body{
      padding:15px !important;
    }
    .el-upload-list__item:first-child{
      margin-top: 0 !important;
    }
</style>
